module.exports = __webpack_public_path__ + "static/media/carroussel_22.1e8d608a.jpg";